var doc = {
    content: '(block|layoutSection)+',
    marks: 'alignment breakout indentation link',
};

export { doc };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/doc.js